import {User} from './shared/models/response/user';
import {Constant} from './shared/common/constant';
import {Path} from './shared/common/path';
import {Endpoint} from './shared/common/endpoint';

export class ComponentPermission {

  static currentUser(): User {
    const dataStr = localStorage.getItem(Constant.LS_CURRENT_USER_KEY);
    return JSON.parse(dataStr);
  }

  static getNavigation(): any[] {
    let navItems = JSON.parse(JSON.stringify(ComponentPermission.navItems));
    navItems.forEach(navItem => {
      if (navItem.permission !== ComponentPermission.HOMEPAGE) {
        navItem.display = false;
        navItem.class = 'firstMenu';
        if (navItem.children) {
          navItem.children.forEach(child => {
            child.display = false;
            child.class = 'secondMenu';
          });
        }
      }
    });
    const aclActions = this.currentUser().aclActions;
    if (aclActions) {
      aclActions.forEach(aclAction => {
        const uiComponents = JSON.parse(aclAction.uiComponent);
        uiComponents.forEach(component => {
          navItems.forEach(navItem => {
            if (navItem.permission && navItem.permission === component && ComponentPermission.isTenantAllowed(navItem)) {
              navItem.display = true;
            }
            if (navItem.children) {
              navItem.children.forEach(child => {
                if (child.permission && child.permission === component && ComponentPermission.isTenantAllowed(child)) {
                  child.display = true;
                  navItem.display = true;
                }
              });
            }
          });
        });
      });
    }
    navItems = navItems.filter(navItem => navItem.display && ComponentPermission.isTenantAllowed(navItem));
    navItems.forEach(navItem => {
      if (navItem.children) {
        navItem.children = navItem.children.filter(child => child.display && ComponentPermission.isTenantAllowed(child));
      }
    });
    return navItems;
  }

  static isTenantAllowed(navItem: any): boolean {
    if (!navItem.partnerNames || navItem.partnerNames.length === 0) {
      return true;
    }
    return navItem.partnerNames.indexOf(ComponentPermission.getCurrentPartnerName()) >= 0;
  }

  static getCurrentPartnerName(): string {
    const endpoint = Endpoint.endpoint.find(item => item.domain === window.location.hostname);
    if (endpoint && endpoint.siteName) {
      return endpoint.siteName;
    }
    return Path.PARTNER_NAME;
  }

  static isFinancialPressureFeatureEnabled(): boolean {
    return ComponentPermission.getCurrentPartnerName() === 'RedEarth';
  }

  static isAccess(permission: string): boolean {
    const aclActions = this.currentUser().aclActions;
    let isAccess = false;
    if (aclActions) {
      aclActions.forEach(aclAction => {
        const uiComponents = JSON.parse(aclAction.uiComponent);
        uiComponents.forEach(component => {
          if (component === permission) {
            isAccess = true;
          }
        });
      });
    }
    return isAccess;
  }

  static HOMEPAGE = 'homepage';

  // ANSWER
  static ANSWER_CREATE = 'answer.create';
  static ANSWER_DELETE = 'answer.delete';
  static ANSWER_EDIT = 'answer.edit';
  static ANSWER_LIST = 'answer.list';
  // CITY
  static CITY_CREATE = 'city.create';
  static CITY_DELETE = 'city.delete';
  static CITY_EDIT = 'city.edit';
  static CITY_LIST = 'city.list';
  // CLIENT
  static CLIENT_BOARD = 'client.board';
  static CLIENT_BOARD_CLICK = 'client.board.click';
  static CLIENT_BOARD_SEARCH = 'client.board.search';
  static CLIENT_CREATE = 'client.create';
  static CLIENT_CREATE_BATCH = 'client.create.batch';
  static CLIENT_CREATE_SHORTCUT = 'client.create.shortcut';
  static CLIENT_DELETE = 'client.delete';
  static CLIENT_EDIT = 'client.edit';
  static CLIENT_ALL = 'client.all';
  static CLIENT_INDOOR = 'client.indoor';
  static CLIENT_LIST = 'client.list';
  static CLIENT_MARKET = 'client.market';
  static CLIENT_OUTDOOR = 'client.outdoor';
  static CLIENT_SEARCH = 'client.search';
  static CLIENT_LISTING_DETAILS = 'client.listing.details';
  static CLIENT_RENTAL_DETAILS = 'client.rental.details';
  // RECRUITMENT
  static RECRUITMENT_LIST = 'recruitment.list';
  // COMPANY
  static COMPANY_BOARD = 'company.board';
  static COMPANY_BOARD_CLICK = 'company.board.click';
  static COMPANY_CREATE = 'company.create';
  static COMPANY_DELETE = 'company.delete';
  static COMPANY_EDIT = 'company.edit';
  static COMPANY_LIST = 'company.list';
  // CUSTOMER
  static CUSTOMER_BOARD = 'customer.board';
  static CUSTOMER_BOARD_CLICK = 'customer.board.click';
  static CUSTOMER_CREATE = 'customer.create';
  static CUSTOMER_DELETE = 'customer.delete';
  static CUSTOMER_EDIT = 'customer.edit';
  static CUSTOMER_LIST = 'customer.list';
  static CUSTOMER_MERGE = 'customer.merge';
  static CUSTOMER_SEARCH = 'customer.search';
  static CUSTOMER_ACCESS_ANYWHERE = 'customer.access.anywhere';
  static CUSTOMER_OPEN_HOME = 'customer.open.home';
  // DASHBOARD
  static DASHBOARD_CALLBACK = 'dashboard.callback';
  static DASHBOARD_DOB = 'dashboard.dob';
  static DASHBOARD_DUPLICATE = 'dashboard.duplicate';
  static DASHBOARD_OVERVIEW = 'dashboard.overview';
  static DASHBOARD_OVERVIEW_CLICK = 'dashboard.overview.click';
  static DASHBOARD_PURCHASE = 'dashboard.purchase';
  static DASHBOARD_DATA_REPORT = 'dashboard.data.report';
  static DASHBOARD_ONE_ON_ONE = 'dashboard.one.on.one';
  static DASHBOARD_RATIO = 'dashboard.ratio';
  static DASHBOARD_OVERVIEW_TEAM = 'dashboard.overview.team';
  static DASHBOARD_VISUAL_BOARD = 'dashboard.visual.board';
  static DASHBOARD_RENTAL_BOARD = 'dashboard.rental.board';
  static DASHBOARD_RENTAL_TEAM = 'dashboard.rental.team';
  static DASHBOARD_RENTAL_CLICK = 'dashboard.rental.click';
  // FARM
  static FARM_CREATE = 'farm.create';
  static FARM_DELETE = 'farm.delete';
  static FARM_EDIT = 'farm.edit';
  static FARM_LIST = 'farm.list';
  // GLOBAL
  static GLOBAL_ADDRESS = 'global.address';
  static GLOBAL_PHONE = 'global.phone';
  static GLOBAL_PHONE_COPY = 'global.phone.copy';
  static GLOBAL_PHONE_LINK = 'global.phone.link';
  static GLOBAL_PHONE_MERGE = 'global.phone.merge';
  static GLOBAL_PHONE_MOVE = 'global.phone.move';
  static GLOBAL_FILTER_USER = 'global.filter.user';
  // GROUP
  static GROUP_CREATE = 'group.create';
  static GROUP_DELETE = 'group.delete';
  static GROUP_EDIT = 'group.edit';
  static GROUP_LIST = 'group.list';
  // OFFICE
  static OFFICE_CREATE = 'office.create';
  static OFFICE_DELETE = 'office.delete';
  static OFFICE_EDIT = 'office.edit';
  static OFFICE_LIST = 'office.list';
  static OFFICE_PROPERTY = 'office.property';
  static OFFICE_ASSIGN = 'office.assign';
  static OFFICE_MANAGEMENT_RATE = 'office.management.rate';
  // PERMISSION
  static PERMISSION_CREATE = 'permission.create';
  static PERMISSION_DELETE = 'permission.delete';
  static PERMISSION_EDIT = 'permission.edit';
  static PERMISSION_LIST = 'permission.list';
  // QUESTION
  static QUESTION_CREATE = 'question.create';
  static QUESTION_DELETE = 'question.delete';
  static QUESTION_EDIT = 'question.edit';
  static QUESTION_LIST = 'question.list';
  // SOS
  static SOS_DAILY = 'sos.daily';
  // BLOG
  static BLOG_LIST = 'blog.list';
  static BLOG_CREATE = 'blog.create';
  static BLOG_DELETE = 'blog.delete';
  static BLOG_EDIT = 'blog.edit';
  // STREET
  static STREET_CREATE = 'street.create';
  static STREET_DELETE = 'street.delete';
  static STREET_EDIT = 'street.edit';
  static STREET_LIST = 'street.list';
  // SUBURB
  static SUBURB_CREATE = 'suburb.create';
  static SUBURB_DELETE = 'suburb.delete';
  static SUBURB_EDIT = 'suburb.edit';
  static SUBURB_LIST = 'suburb.list';
  // TAG
  static TAG_CREATE = 'tag.create';
  static TAG_DELETE = 'tag.delete';
  static TAG_EDIT = 'tag.edit';
  static TAG_LIST = 'tag.list';
  // TASK
  static TASK_CALENDAR = 'task.calendar';
  static TASK_CREATE = 'task.create';
  static TASK_DELETE = 'task.delete';
  static TASK_EDIT = 'task.edit';
  static TASK_STATUS_CREATE = 'task.status.create';
  static TASK_STATUS_DELETE = 'task.status.delete';
  static TASK_STATUS_EDIT = 'task.status.edit';
  static TASK_STATUS_LIST = 'task.status.list';
  static TASK_TYPE_CREATE = 'task.type.create';
  static TASK_TYPE_DELETE = 'task.type.delete';
  static TASK_TYPE_EDIT = 'task.type.edit';
  static TASK_TYPE_LIST = 'task.type.list';
  // TEMPLATE
  static TEMPLATE_CREATE = 'template.create';
  static TEMPLATE_DELETE = 'template.delete';
  static TEMPLATE_EDIT = 'template.edit';
  static TEMPLATE_LIST = 'template.list';
  // USER
  static USER_CREATE = 'user.create';
  static USER_DELETE = 'user.delete';
  static USER_EDIT = 'user.edit';
  static USER_LIST = 'user.list';
  static USER_LOW_LEVEL = 'user.low.level';
  static USER_UPDATE_DAILY_GOAL = 'user.update.daily.goal';
  // ZONE
  static ZONE_CREATE = 'zone.create';
  static ZONE_DELETE = 'zone.delete';
  static ZONE_EDIT = 'zone.edit';
  static ZONE_LIST = 'zone.list';
  // RENTAL
  static RENTAL_PROPERTY_MANAGER = 'rental.property.manager';
  static RENTAL_LEVEL4_DETAILS = 'rental.level4.details';

  //  MANAGEMENT

  static MANAGEMENT_MARKETING_SCHEDULE = 'management.marketing.schedule';
  static MANAGEMENT_BANK_RATE = 'management.bank.rate';

  static navItems: any[] = [
    {
      name: 'CRM',
      url: '/pages/dashboard/index',
      class: 'homepage-icon',
      display: true,
      permission: ComponentPermission.HOMEPAGE,
    },
    {
      name: '1. Dashboard',
      // url: '/pages/dashboard/overview',
      icon: 'icon-briefcase',
      // permission: ComponentPermission.MENU_DASHBOARD,
      children: [
        {
          name: '1.1 Overview',
          url: '/pages/dashboard/overview',
          icon: 'icon-speedometer',
          permission: ComponentPermission.DASHBOARD_OVERVIEW,
        },
        {
          name: '1.2 Callback Date',
          url: '/pages/dashboard/callback-date',
          icon: 'icon-phone',
          permission: ComponentPermission.DASHBOARD_CALLBACK,
        },
        {
          name: '1.3 Purchase Date',
          url: '/pages/prospect/purchase-date',
          icon: 'icon-wallet',
          permission: ComponentPermission.DASHBOARD_PURCHASE,
        },
        {
          name: '1.4 Date of birth',
          url: '/pages/dashboard/dob',
          icon: 'icon-event',
          permission: ComponentPermission.DASHBOARD_DOB,
        },
        {
          name: '1.5 Duplicated Records',
          url: '/pages/dashboard/search/phone/duplicate',
          icon: 'icon-phone',
          permission: ComponentPermission.DASHBOARD_DUPLICATE,
        },
        {
          name: '1.6 Data Report',
          url: '/pages/dashboard/data-report',
          icon: 'icon-check',
          permission: ComponentPermission.DASHBOARD_DATA_REPORT,
        },
        {
          name: '1.7 Visual Board',
          url: '/pages/dashboard/visual-board',
          icon: 'icon-menu',
          permission: ComponentPermission.DASHBOARD_VISUAL_BOARD,
        },
        {
          name: '1.8 Rental Board',
          url: '/pages/dashboard/rental-board',
          icon: 'icon-menu',
          permission: ComponentPermission.DASHBOARD_VISUAL_BOARD,
        }
      ]
    },
    {
      name: '2. User Management',
      // url: '/notifications',
      icon: 'icon-people',
      // permission: ComponentPermission.MENU_USER_MANAGEMENT,
      children: [
        {
          name: '2.1 User',
          url: '/pages/user-management/user',
          icon: 'icon-user',
          permission: ComponentPermission.USER_LIST,
        },
        {
          name: '2.2 Group',
          url: '/pages/user-management/group',
          icon: 'icon-people',
          permission: ComponentPermission.GROUP_LIST,
        },
        {
          name: '2.3 Permission',
          url: '/pages/user-management/permission',
          icon: 'icon-check',
          permission: ComponentPermission.PERMISSION_LIST,
        }
      ]
    },
    {
      name: '3. SOS',
      // url: '/notifications',
      icon: 'icon-book-open',
      // permission: ComponentPermission.MENU_SOS,
      children: [
        {
          name: '3.1 Question',
          url: '/pages/sos/question',
          icon: 'icon-question',
          permission: ComponentPermission.QUESTION_LIST,
        },
        {
          name: '3.2 Answer',
          url: '/pages/sos/answer',
          icon: 'icon-note',
          permission: ComponentPermission.ANSWER_LIST,
        },
        {
          name: '3.3 Daily',
          url: '/pages/sos/daily',
          icon: 'icon-notebook',
          permission: ComponentPermission.SOS_DAILY,
        },
        {
          name: '3.4 Blog',
          url: '/pages/sos/blog',
          icon: 'icon-notebook',
          permission: ComponentPermission.BLOG_LIST,
        }
      ]
    },
    {
      name: '4. Task',
      // url: '/notifications',
      icon: 'icon-calendar',
      // permission: ComponentPermission.MENU_TASK,
      children: [
        {
          name: '4.1 Task Calendar',
          url: '/pages/task/calendar',
          icon: 'icon-calendar',
          permission: ComponentPermission.TASK_CALENDAR,
        },
        {
          name: '4.2 Task Type',
          url: '/pages/task/type/list',
          icon: 'icon-options-vertical',
          permission: ComponentPermission.TASK_TYPE_LIST,
        },
        {
          name: '4.3 Task Status',
          url: '/pages/task/status/list',
          icon: 'icon-screen-tablet',
          permission: ComponentPermission.TASK_STATUS_LIST,
        },
        // {
        //   name: 'Task Create',
        //   url: '/pages/task/create-task',
        //   icon: 'fa fa-plus',
        //   permission: ComponentPermission.TASK_CREATE,
        // },
      ],
    },
    {
      name: '5. Client',
      // url: '/notifications',
      icon: 'icon-home',
      // permission: ComponentPermission.MENU_CLIENT,
      children: [
        // {
        //   name: '5.1 Client List',
        //   url: '/pages/prospect/list',
        //   icon: 'icon-layers',
        //   permission: ComponentPermission.CLIENT_LIST,
        // },
        {
          name: '5.1 Client List',
          url: '/pages/prospect/client-list',
          icon: 'icon-list',
          permission: ComponentPermission.CLIENT_LIST,
        },
        {
          name: '5.2 Client Board',
          url: '/pages/prospect/client-board',
          icon: 'icon-screen-desktop',
          permission: ComponentPermission.CLIENT_BOARD,
        },
        {
          name: '5.3 Company Board',
          url: '/pages/prospect/company-board',
          icon: 'icon-screen-desktop',
          permission: ComponentPermission.COMPANY_BOARD,
        },
        {
          name: '5.4 Company List',
          url: '/pages/prospect/company/list',
          icon: 'icon-list',
          permission: ComponentPermission.COMPANY_LIST,
        },
        {
          name: '5.5 Market Watching',
          url: '/pages/prospect/daily-checklist',
          icon: 'icon-list',
          permission: ComponentPermission.CLIENT_LIST,
          partnerNames: ['RedEarth', 'Local'],
        }
      ],
    },
    {
      name: 'Recruitment',
      // url: '/notifications',
      icon: 'icon-user',
      // permission: ComponentPermission.MENU_CUSTOMER,
      children: [
        {
          name: 'Recruiment List',
          url: '/pages/recruitment/recruitment-list',
          icon: 'icon-user-follow',
          permission: ComponentPermission.RECRUITMENT_LIST,
        }]
    },
    {
      name: '6. Customer',
      // url: '/notifications',
      icon: 'icon-basket-loaded',
      // permission: ComponentPermission.MENU_CUSTOMER,
      children: [
        {
          name: '6.1 Customer List',
          url: '/pages/buyer/list',
          icon: 'icon-list',
          permission: ComponentPermission.CUSTOMER_LIST,
        },
        {
          name: '6.2 Customer Board',
          url: '/pages/buyer/board',
          icon: 'icon-screen-desktop',
          permission: ComponentPermission.CUSTOMER_BOARD,
        },
        {
          name: '6.3 Open Home',
          url: '/pages/buyer/open-home',
          icon: 'icon-home',
          permission: ComponentPermission.CUSTOMER_BOARD,
        },
        {
          name: '6.4 Customer List V2',
          url: '/pages/buyer/list-v2',
          icon: 'icon-list',
          permission: ComponentPermission.CUSTOMER_LIST,
          partnerNames: ['RedEarth', 'Local'],
        },
      ],
    },
    {
      name: '7. Address',
      // url: '/notifications',
      icon: 'icon-location-pin',
      // permission: ComponentPermission.MENU_ADDRESS,
      children: [
        // {
        //   name: 'City',
        //   url: '/pages/address/city',
        //   icon: 'icon-map',
        //   permission: ComponentPermission.CITY_LIST,
        // },
        // {
        //   name: 'Zone',
        //   url: '/pages/address/zone',
        //   icon: 'icon-directions',
        //   permission: ComponentPermission.ZONE_LIST,
        // },
        {
          name: '7.1 Suburb',
          url: '/pages/address/suburb',
          icon: 'icon-direction',
          permission: ComponentPermission.SUBURB_LIST,
        },
        // {
        //   name: 'Farm',
        //   url: '/pages/address/farm',
        //   icon: 'icon-menu',
        //   permission: ComponentPermission.FARM_LIST,
        // },
        {
          name: '7.2 Street',
          url: '/pages/address/street',
          icon: 'icon-pin',
          permission: ComponentPermission.STREET_LIST,
        },
      ],
    },
    {
      name: '8. Other',
      // url: '/other',
      icon: 'icon-star',
      // permission: ComponentPermission.MENU_OTHER,
      children: [
        {
          name: '8.1 Tag',
          url: '/pages/other/category',
          icon: 'icon-tag',
          permission: ComponentPermission.TAG_LIST,
        },
        {
          name: '8.2 Template',
          url: '/pages/other/template',
          icon: 'icon-envelope',
          permission: ComponentPermission.TEMPLATE_LIST,
        },
        {
          name: '8.3 Office',
          url: '/pages/other/office',
          icon: 'icon-list',
          permission: ComponentPermission.OFFICE_LIST,
        },
      ],
    },
    {
      name: '9. Management',
      // url: '/other',
      icon: 'icon-docs',
      // permission: ComponentPermission.MENU_OTHER,
      children: [
        {
          name: 'Marketing',
          url: '/pages/management/marketing-schedule',
          icon: 'icon-badge',
          permission: ComponentPermission.MANAGEMENT_MARKETING_SCHEDULE,
        },
        {
          name: 'Financial',
          url: '/pages/management/financial',
          icon: 'icon-graph',
          permission: ComponentPermission.MANAGEMENT_BANK_RATE,
        }
      ],
    },
    {
      name: '10. Compare',
      url: '/pages/compare',
      icon: 'icon-chart',
      display: true,
      permission: ComponentPermission.HOMEPAGE,
      partnerNames: ['RedEarth', 'Local'],
    }
  ];
}
